module.exports = __webpack_public_path__ + "static/media/promotionResumptionPackageUnder40.7a8f63cc.webp";